import { Box, Button, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useSpring, animated } from "react-spring";

import gradient_lg_imgUrl from "@/assets/images/subscription/gradient.png";
import map_imgUrl from "@/assets/images/subscription/map_lg.png";
import map_sm_imgUrl from "@/assets/images/subscription/map_sm.png";
import mobile_imgUrl from "@/assets/images/subscription/mobile.png";
import mobile_thumbUrl from "@/assets/images/subscription/mobile_thumbnail.png";
import { ROUTES } from "@/utils/navigation";

const ShopDevices = () => {
  const [imageLoaded, setImageLoaded] = useState(false); // Image loading state

  // Handle image loading
  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const fadeInProps = useSpring({
    opacity: imageLoaded ? 1 : 0,
    from: { opacity: 0 },
    config: { duration: 300 },
  });

  const fadeInThumbProps = useSpring({
    opacity: imageLoaded ? 0 : 1, // Hide thumbnail when full image is loaded
    from: { opacity: 1 },
    config: { duration: 300 },
    filter: `blur(10px)`,
  });

  return (
    <Box
      mt={{ xs: 5 }}
      borderRadius={5}
      bgcolor="#FF7B29"
      px={{ xs: 2, md: 0 }}
      py={{ xs: 2, md: 0 }}
      sx={{
        backgroundImage: {
          xs: `url(${map_sm_imgUrl})`,
          md: `url(${gradient_lg_imgUrl})`,
        },
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Grid container columnSpacing={{ xs: 0, md: 2.5 }}>
        <Grid
          item
          xs={12}
          md={6}
          display={{ xs: "block", md: "flex" }}
          justifyContent="center"
          flexDirection="column"
          alignItems="start"
        >
          <Box pl={{ md: 5, lg: 8 }} py={{ xs: 0, md: 5, lg: 8.75, xl: 9.25 }}>
            <Typography
              variant="h2"
              component="p"
              color="white"
              mb={{ xs: 4, md: 6 }}
              maxWidth={540}
            >
              Do you still need a tracking device? 
            </Typography>

            <Button
              variant="soft"
              component={Link}
              size="large"
              sx={{ display: { xs: "none", md: "inline-block" } }}
              to={ROUTES.solutions}
            >
              Shop devices
            </Button>
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          sx={{
            backgroundImage: {
              xs: ``,
              md: `url(${map_imgUrl})`,
            },
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Box
            pt={{ xs: 0, md: 2.5 }}
            pr={{ md: 5, lg: 8 }}
            display="flex"
            justifyContent="center"
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",

                img: {
                  width: "100%",
                  height: "auto",
                  display: "block",
                  mx: "auto",
                  maxWidth: { xs: "auto", md: 515 },
                },
              }}
            >
              <animated.img
                src={mobile_thumbUrl}
                alt={`preview`}
                style={{
                  ...fadeInThumbProps,
                  position: "relative",
                  zIndex: 1,
                  transition: "opacity 0.3s ease",
                }}
              />

              <animated.img
                src={mobile_imgUrl}
                alt="mobile"
                loading="lazy"
                style={{
                  ...fadeInProps,
                  position: "absolute",
                  zIndex: 2,
                  top: 1,
                  left: "50%",
                  transform: "translateX(-50%)",
                  transition: "opacity 0.3s ease",
                }}
                onLoad={handleImageLoad}
              />
            </Box>
          </Box>
        </Grid>
        <Button
          variant="soft"
          component={Link}
          size="large"
          fullWidth
          sx={{
            display: { xs: "flex", md: "none" },
            mt: { xs: 4, md: 0 },
          }}
          to={ROUTES.solutions}
        >
          Shop devices
        </Button>
      </Grid>
    </Box>
  );
};

export default ShopDevices;
